import React, {useEffect} from "react";
import {
    Card,
    Typography,
    List,
    ListItem,
    ListItemPrefix,
} from "@material-tailwind/react";
import CustomIcon from "../../components/general/CustomIcon";
import {useTranslation} from "react-i18next";
import {decodeIdToken} from "../../services/session/apiSession";
import Cookies from "js-cookie";
import {ID_TOKEN} from "../../conf";
import {useFindPermissionsDepartment} from "../../services/admin-user/apiPermission";
import {UserDepartmentInterface} from "../../services/interface/UserDepartmentInterface";
import LoadingPage from "../../components/general/LoadingPage";

interface Props {
    department?: UserDepartmentInterface;
    setDepartment: React.Dispatch<React.SetStateAction<UserDepartmentInterface | undefined>>;
}
export default function SelectDepartment({department, setDepartment}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    const {mutate: findAllDepartments, isPending: isLoading, data: successFind} = useFindPermissionsDepartment()
    const [list, setList] = React.useState<UserDepartmentInterface[] | undefined>()

    useEffect(() => {
        const user = decodeIdToken(Cookies.get(ID_TOKEN))
        if (user && user?.preferred_username) {
            findAllDepartments({idUser: user?.preferred_username.toUpperCase()})
        }
    }, []);

    useEffect(() => {
        if (successFind && successFind.length > 0) {
            setDepartment(successFind[0])
            setList(successFind)
        }
    }, [successFind]);

    return (
        <>
            <Card placeholder={''} className="overflow-y-auto h-[250px] sm:h-full w-full sm:max-w-[20rem] p-4 shadow-xl bg-primary">
                <div className="mb-2 p-4">
                    <Typography placeholder={''} variant="h5" color="white">
                        {t('departments')}
                    </Typography>
                </div>
                {isLoading && <LoadingPage/>}
                <List placeholder={''}>
                    {(list && list.length > 0) ? list.map((departmentItem, index) => (
                        <ListItem
                            selected={department === departmentItem}
                            placeholder={''}
                            key={`menu-${index}`}
                            className={'text-white'}
                            onClick={() => {
                                setDepartment(departmentItem)
                            }}
                        >
                            <ListItemPrefix placeholder={''}>
                                {departmentItem.departmentIcon ? <CustomIcon iconName={departmentItem.departmentIcon}/> : <></>}
                            </ListItemPrefix>
                            {departmentItem.department}
                        </ListItem>
                    )) : <></>}
                </List>
            </Card>
        </>
    )
}
